import { useEffect } from "react";

/** Safari's keyboard can shrink the visual viewport without changing 100dvh. */
export function trackVisualViewport(): () => void {
  const root = document.documentElement;
  const viewport = window.visualViewport;
  const refresh = () => {
    // Keep pinch zoom available; resizing the layout while zooming causes jumps.
    if (viewport && Math.abs(viewport.scale - 1) > 0.05) return;
    const height = viewport?.height ?? window.innerHeight;
    root.style.setProperty("--visible-height", `${Math.round(height)}px`);
    root.style.setProperty("--visible-top", `${Math.round(viewport?.offsetTop ?? 0)}px`);
    const editing = document.activeElement?.matches("input, textarea, [contenteditable='true']");
    root.toggleAttribute("data-keyboard-open", Boolean(editing && window.innerHeight - height > 100));
  };
  viewport?.addEventListener("resize", refresh);
  viewport?.addEventListener("scroll", refresh);
  window.addEventListener("resize", refresh);
  document.addEventListener("focusin", refresh);
  document.addEventListener("focusout", refresh);
  refresh();
  return () => {
    viewport?.removeEventListener("resize", refresh);
    viewport?.removeEventListener("scroll", refresh);
    window.removeEventListener("resize", refresh);
    document.removeEventListener("focusin", refresh);
    document.removeEventListener("focusout", refresh);
    root.style.removeProperty("--visible-height");
    root.style.removeProperty("--visible-top");
    root.removeAttribute("data-keyboard-open");
  };
}

export function useVisualViewport() { useEffect(trackVisualViewport, []); }
